import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
	try {
		const runtimeConfig = useRuntimeConfig()
		const gtmId = runtimeConfig.public.gtm.id

		const gtm = createGtm({
			id: gtmId,
			enabled: true,
		})

		nuxtApp.vueApp.use(gtm)
	} catch (error) {
		console.error('GTM setup error:', error)
	}
})
